import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { API_ROUTES } from '../../../constants/api_routes';
import { connect, useDispatch } from 'react-redux';
import { updateDailyReportsPagination } from '../../../store/actions/reports/reports_action';
import { Checkbox, Container, FormControlLabel, Grid, makeStyles } from '@material-ui/core';
import Autocomplete from '../../ui_components/autocomplete';
import DatePicker from '../../ui_components/date_picker';
import ReportsTable from './daily_reports_table';
import { isValid } from 'date-fns';
import CheckboxesTags from '../../ui_components/checkboxes_tags';
import { reduceArrayOfOptions } from '../../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2),
        maxWidth: 'none'
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

const setZeroTime = (date) => {
    return date ? new Date(date.setHours(0, 0, 0, 0)) : null;
}

const DailyReportsList = ({ dailyReports }) => {

    const { container, alignCenter } = useStyles();
    const [customer, setCustomer] = useState(null);
    const [worker, setWorker] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isPayed, setIsPayed] = useState(false);
    //default type doctor
    const [type, setType] = useState(1);
    const dispatch = useDispatch();

    const { filters } = dailyReports;

    useEffect(() => {
        if (filters.customer) {
            setCustomer(filters.customer);
        }
        if (filters.worker) {
            setWorker(filters.worker);
        }
        if (filters.startDate) {
            setStartDate(filters.startDate);
        }
        if (filters.endDate) {
            setEndDate(filters.endDate);
        }
        if (filters.isPayed) {
            setIsPayed(Boolean(filters.isPayed));
        }
    }, [])

    const handleTypesChange = (e, values) => {
        if(values.length)
            setType(values[0].id);
        else
            setType(1);
        dispatch(updateDailyReportsPagination({ ...dailyReports, page: 0, filters: { ...filters, types: reduceArrayOfOptions(values) }}));
    }

    const handleCustomerObject = async (object) => {
        const customer = object;
        setCustomer(customer);
        dispatch(updateDailyReportsPagination({...dailyReports, page: 0, filters: { ...filters, customer }}));
    }

    const handleWorkerObject = async (object) => {
        const worker = object;
        setWorker(worker);
        dispatch(updateDailyReportsPagination({...dailyReports, page: 0, filters: { ...filters, worker }}));
    }

    const handleStartDateChange = async (e) => {
        const startDate = setZeroTime(e);
        if (startDate === null || isValid(startDate)) {
            setStartDate(startDate);
            dispatch(updateDailyReportsPagination({...dailyReports, page: 0, filters: { ...filters, startDate }}));
        }
    }

    const handleEndDateChange = async (e) => {
        const endDate = setZeroTime(e);
        if (endDate === null || isValid(endDate)) {
            setEndDate(endDate);
            dispatch(updateDailyReportsPagination({...dailyReports, page: 0, filters: { ...filters, endDate }}));
        }
    }

    const handleCheckIsPayed = async (e) => {
        const isPayed = e.target.checked;
        setIsPayed(isPayed);
        dispatch(updateDailyReportsPagination({...dailyReports, page: 0, filters: { ...filters, isPayed }}));
    }

    return (
        <Container className={container}>
            <Grid container item xs={12} justify="center" alignItems="center" spacing={1}>
                <Grid item xs={12} md={12}>
                    <Autocomplete
                        name="customer"
                        label="Klijent (prazno uključuje sve)"
                        placeholder="Klijent"
                        api={API_ROUTES.CUSTOMERS}
                        handleObject={handleCustomerObject}
                        preloadValue={customer}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        name="worker"
                        label="Radnik (prazno uključuje sve)"
                        placeholder="Radnik"
                        api={API_ROUTES.WORKERS}
                        handleObject={handleWorkerObject}
                        preloadValue={worker}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CheckboxesTags
                        value={filters.types}
                        limitTags={1}
                        onChange={handleTypesChange}
                        options={[
                            { id: 1, name: 'Doktor'},
                            { id: 2, name: 'Tehničar' },
                            { id: 3, name: 'Osiguravajuća kuća' }
                        ]}
                        placeholder='Tipovi radnika'
                        label='Tipovi radnika'
                        loadingText='Učitavanje'
                        maxWidth="auto"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DatePicker
                        name="startDate"
                        value={startDate}
                        label="Početak"
                        placeholder="Početak"
                        onChange={handleStartDateChange}
                        readOnly={false}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DatePicker
                        name="endDate"
                        value={endDate}
                        label="Kraj"
                        placeholder="Kraj"
                        onChange={handleEndDateChange}
                        readOnly={false}
                    />
                </Grid>
                <Grid item xs={12} md={7} className={alignCenter}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={isPayed}
                                onChange={handleCheckIsPayed}
                            />
                        }
                        label="Plaćeno?"
                    />
                </Grid>
            </Grid>
            <ReportsTable
                type={type}
            />
        </Container>
    )
}

DailyReportsList.propTypes = {
    dailyReports: PropTypes.object
}

const mapStateToProps = (state) => ({
    dailyReports: state.dailyReports
});

export default connect(mapStateToProps)(DailyReportsList);
